// "use client"

import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "hooks/auth";
import Navigation from "pages/(app)/Navigation";
import Loading from "pages/(app)/Loading";
import Sidebar, { LAYOUT_RISIKO_VAR_ARR } from "components/Sidebar";
import "bootstrap/dist/css/bootstrap.min.css";
import { getStorage, clearStorage } from "pages/Utils";
import { usePathname, useRouter } from "components/Navigation";
import NotFoundPage from "pages/not-found";
import axios from "lib/axios";
import { saveStorage, showToastr } from "pages/Utils";
import { api_services } from "hooks/api_services";

const is_activated_page404 = false;

const AppLayout = ({ children, header }) => {
  const pathname = usePathname();
  const router = useRouter();
  // const { user } = useAuth({ middleware: "auth" });
  const [user, setuser] = useState(null);
  const [is_page_error, setis_page_error] = useState(false);
  const [accessrendered, setaccessrendered] = useState(false);
  const [errors, setErrors] = useState({});

  sessionStorage.setItem("path", "index");
  // console.log("pathname", pathname);

  const path = pathname?.split("/")[2];

  if (path == "add" || path == "edit") {
    sessionStorage.setItem("path", path);
  }

  const page_url = pathname?.split("/")[1];

  if (page_url == "mt_risk_kriteria_dampak") {
    const path1 = pathname?.split("/")[3];
    // console.log("path1", path1);
    if (path1 == "add" || path1 == "edit") {
      sessionStorage.setItem("path", path1);
    }
    sessionStorage.setItem("page_url", "mt_risk_kriteria_dampak/" + path);
  } else if (page_url == "mt_risk_matrix") {
    sessionStorage.setItem("page_url", "mt_risk_matrix/1");
  } else {
    sessionStorage.setItem("page_url", page_url);
  }

  // const user = {
  //   name: "Robin",
  //   email: "robinbuah@gmail.com",
  // };
  const { postapi_services, getapi_services } = api_services({
    api_path: "/get_session",
  });

  const initialized = useRef(false);
  useEffect(() => {
    if (!initialized.current) {
      // console.log("user=>layout=>");
      // console.log(user);
      cekAccessFromSSO();
      // const user_loginObj = getStorage("user_login");
      initialized.current = true;

      checking_page_error();
    }
  }, [pathname]);

  const checking_page_error = async () => {
    const user_loginObj = await getStorage("user_login");
    if (!user_loginObj) return;

    const user_login = JSON.parse(user_loginObj);
    const access_method = user_login.accessmethod;

    const pathname_arr = pathname.split("/");
    const page = pathname_arr[1];

    // console.log('AppLayout')
    // console.log(user_login)
    // console.log(access_method)
    // console.log(LAYOUT_RISIKO_VAR_ARR)
    // console.log(pathname)
    // console.log(page)

    let is_page_error = true;
    for (let m in access_method) {
      if (m == page) {
        is_page_error = false;
        break;
      }
    }

    if (is_page_error) {
      for (let i = 0; i < LAYOUT_RISIKO_VAR_ARR.length; i++) {
        if (LAYOUT_RISIKO_VAR_ARR[i] == page) {
          is_page_error = false;
          break;
        }
      }
    }

    if (is_activated_page404) {
      setis_page_error(is_page_error);
    }
  };

  const cekAccessFromSSO = async () => {
    const user_loginObj = getStorage("user_login");

    // console.log("cekAccessFromSSO");
    // console.log(user_loginObj);

    // return;
    if (!user_loginObj) {
      await clearStorage();
      router.push("/login");
      return;
    }

    const user_login = JSON.parse(user_loginObj);
    setuser(user_login.user);
    // console.log("user_login.user", user_login.user);

    if (!user_login) {
      const response = await getapi_services({
        setErrors,
      });
      // console.log(response);
      saveStorage("user_login", JSON.stringify(response));
      setaccessrendered(true);
    } else {
      setaccessrendered(true);
    }
  };

  // const cekAccessFromSSO = async () => {
  //   const user_loginObj = getStorage("user_login");
  //   const user_login = JSON.parse(user_loginObj);
  //   console.log("user login");
  //   console.log(user_login);
  //   if (!user_login) {
  //     const response = await getapi_services({
  //       setErrors,
  //     });
  //     console.log(response);
  //     saveStorage("user_login", JSON.stringify(response));
  //     setaccessrendered(true);
  //   } else {
  //     setaccessrendered(true);
  //   }
  // };

  // console.log("user", user);
  // console.log("accessrendered", accessrendered);
  if (!user || !accessrendered) {
    return <Loading />;
  }

  return (
    <div className="min-h-screen bg-gray-100 layout-app">
      {is_page_error ? (
        <NotFoundPage />
      ) : (
        <>
          {accessrendered && <Navigation user={user} />}

          <main className="d-flex layout-app-body">
            {accessrendered && <Sidebar />}
            <div className="flex-1 overflow-y-auto">{children}</div>
          </main>
        </>
      )}
    </div>
  );
};

export default AppLayout;
